import { useBulkUserGroupRoleDelete } from "shared/Role/useDeleteUserGroupRole";

import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";
import { IdpGroupRolesBulkActions } from "../types";
import { IdpGroupRolesBulkActionsPayload } from "./types";
import { RoleBinding } from "../../types";

const useDeleteIdpGroupRolesBulkAction = (): IdpGroupRolesBulkActionsPayload => {
  const [deleteGroupRole] = useBulkUserGroupRoleDelete();

  return {
    key: IdpGroupRolesBulkActions.Delete,
    title: BULK_ACTION_NAMES[IdpGroupRolesBulkActions.Delete],
    resultTitle: BULK_ACTION_RESULTS_TITLE[IdpGroupRolesBulkActions.Delete],
    condition: () => ({ result: true }),
    mutation: (roleBinding: RoleBinding) => deleteGroupRole({ id: roleBinding.id }),
  };
};

export default useDeleteIdpGroupRolesBulkAction;
